import DOMPurify from 'dompurify';

/**
 * Renders HTML content sanitized with DOMPurify.
 * Drop-in replacement for dangerouslySetInnerHTML.
 *
 * Usage:
 *   <SafeHTML html={content} as="div" className="prose" />
 */
export default function SafeHTML({ html, as: Tag = 'div', allowStyles = false, allowIframes = false, ...props }) {
  if (!html) return null;

  const sanitizeOptions = allowStyles
    ? { ADD_TAGS: ['style'], ADD_ATTR: ['style'], FORCE_BODY: true }
    : {};

  if (allowIframes) {
    sanitizeOptions.ADD_TAGS = [...(sanitizeOptions.ADD_TAGS || []), 'iframe'];
    sanitizeOptions.ADD_ATTR = [...(sanitizeOptions.ADD_ATTR || []), 'src', 'width', 'height', 'frameborder', 'allowfullscreen', 'allow', 'sandbox', 'title', 'loading', 'scrolling'];
  }

  // Decode double-escaped HTML entities (e.g. &amp;nbsp; → &nbsp;)
  const decoded = html.replace(/&amp;(#?\w+;)/g, '&$1');

  return (
    <Tag
      {...props}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(decoded, sanitizeOptions) }}
    />
  );
}
